module.exports = __webpack_public_path__ + "createstatic/media/studioIcn.87eb7157.svg";